import '../../../../packages/frontend/components/arti24/arti24.js';
import '../../../../packages/frontend/components/menu/menu-init.js';
import './../../../../packages/frontend/components/lit-animated-picture.js';
import './../../../../packages/frontend/components/lit-animated-snow.js';
import './../../../../packages/frontend/components/lit-animated-snow2.js';
import './components/lit-alpaca-animated-picture.js';
import './components/lit-picture-tile.js';
import './poster-print.js';
import { bindContactForms } from '../../../../packages/frontend/forms/contact-form-submit.js';

// The contact page's rules, as before the shared module took over sending.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE = /^[\d\s+\-()]{9,}$/;
bindContactForms(document, {
    validators: {
        name: (value) => value.length >= 2,
        phone: (value) => {
            const phone = value.replace(/\s/g, '');
            return PHONE.test(phone) && phone.replace(/\D/g, '').length >= 9;
        },
        email: (value) => EMAIL.test(value),
        subject: (value) => value.length >= 3,
        message: (value) => value.length >= 10,
    },
    escapeHtml: true,
    sendingInButton: true,
    hideStatusAfterMs: 5000,
    timeoutMs: 10000,
});
